import styled from 'styled-components';
import { BUTTON_SIZES, TextButton } from 'ui/button';
import { AlertsZeroState, ErrorStatePageError } from 'ui/illustrations';
import {
  PlaceholderDescription,
  PlaceholderState,
  PlaceholderTitle,
} from 'ui/indexPages/PlaceholderState';
import { body2, colors, heading5 } from 'ui/theme';

const StyledPlaceholderState = styled(PlaceholderState)`
  & ${PlaceholderTitle} {
    ${heading5}
  }

  && ${PlaceholderDescription} {
    ${body2}
    color: ${colors.textSecondary};
  }
`;

const StyledTextButton = styled(TextButton)`
  padding-inline: 0;
`;

export const CampaignsHealthMetricsErrorState = ({
  refetch,
}: {
  refetch: () => void;
}) => {
  return (
    <StyledPlaceholderState
      Illustration={ErrorStatePageError}
      title="We’ve hit a snag"
      data-test="send-metrics-error-state"
    >
      Sorry, we’re having trouble loading health information. Come back again later or{' '}
      <StyledTextButton onClick={refetch} size={BUTTON_SIZES.MEDIUM}>
        try reloading.
      </StyledTextButton>
    </StyledPlaceholderState>
  );
};

export const CampaignsHealthMetricsZeroState = () => {
  return (
    <StyledPlaceholderState
      Illustration={AlertsZeroState}
      title="There’s nothing here"
      data-test="send-metrics-zero-state"
    >
      There is no health information for the filters you’ve selected.
    </StyledPlaceholderState>
  );
};
